/*
 * Bundle builder v2 — mobile conversion layer. Loaded deferred by
 * snippets/tnm-builder-v2.liquid (see the comment there for what it does and
 * the rules it keeps). Presentation only; the Torosachi app owns commerce.
 */
  (function () {
    if (window.__tnmBuilderV2) return;
    window.__tnmBuilderV2 = true;

    var mq = window.matchMedia('(max-width: 1023px)');
    /* rate + freeAt: the under-threshold Express rate and the free-shipping unlock
       of the General delivery profile, read from the theme settings the builder
       snippet prints (express_shipping_rate_cents / free_shipping_threshold_cents).
       This said "14.95" in code while checkout charged $9.95 (2026-10-29). */
    var SHIP = (function () {
      var el = document.querySelector('[data-tnm-builder-v2]');
      var rate = el && parseFloat(el.getAttribute('data-express-rate'));
      var freeAt = el && parseFloat(el.getAttribute('data-free-ship-at'));
      return {rate: isFinite(rate) && rate > 0 ? rate : 9.95, freeAt: isFinite(freeAt) ? freeAt : 199};
    })();
    /* Case-lot orders ship free from $150 through the TNMCASEFREESHIP code that
       tnm-case-free-shipping.js applies. The widget total leaves those case lines
       out, so read the cart itself instead of telling a qualifying order the express rate. */
    var caseShip = {free: false, hasCase: false, minimum: 0, at: 0, retries: 0};
    var caseCfg = (function () {
      try { return JSON.parse(document.getElementById('tnm-case-shipping-config').textContent); } catch (e) { return null; }
    })();
    function refreshCaseShip() {
      var now = Date.now();
      if (now - caseShip.at < 4000) return;
      caseShip.at = now;
      fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var code = caseCfg && typeof caseCfg.code === 'string' ? caseCfg.code.toUpperCase() : 'TNMCASEFREESHIP';
          var free = (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code && d.applicable === true; });
          var hasCase = !!(caseCfg && Array.isArray(caseCfg.variants) && (cart.items || []).some(function (i) { return caseCfg.variants.indexOf(Number(i.variant_id)) !== -1 && !i.selling_plan_allocation; }));
          var minimum = caseCfg && Number.isSafeInteger(caseCfg.minimum) ? caseCfg.minimum / 100 : 0;
          if (free !== caseShip.free || hasCase !== caseShip.hasCase) { caseShip.free = free; caseShip.hasCase = hasCase; caseShip.minimum = minimum; schedule(); }
          /* The site-wide gift guard applies the code a moment after load; a
             qualifying case cart is re-read a few times rather than left on the express rate. */
          if (hasCase && !free && minimum > 0 && cart.total_price >= minimum * 100 && (caseShip.retries || 0) < 5) {
            caseShip.retries = (caseShip.retries || 0) + 1;
            setTimeout(function () { caseShip.at = 0; refreshCaseShip(); }, 2500);
          }
        })
        .catch(function () {});
    }
    var money = function (n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var num = function (s) { var m = String(s || '').replace(/,/g, '').match(/\$?\s*(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; };
    var txt = function (el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; };
    var q = function (sel, root) { return (root || document).querySelector(sel); };
    var qa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

    /* Percent the app itself advertises ("10% on every order"). */
    function subPercent() {
      var s = txt(q('.ts-bb__subheading')) + ' ' + txt(q('.ts-bb__sub-label'));
      var m = s.match(/(\d{1,2})%\s*(?:off\s*(?:your\s*)?first box|on every (?:order|box|delivery))/i);
      var p = m ? parseInt(m[1], 10) : NaN;
      return p > 0 && p < 100 ? p : NaN;
    }

    /* Reward stops the widget rendered in its ladder: [{amount,label,met}] */
    function stops() {
      return qa('.tnm-bb-progress-slot .ts-bb__ladder-stop, [data-ts-bundle-builder] .ts-bb__ladder-stop').reduce(function (acc, el) {
        var label = txt(q('.ts-bb__ladder-label', el));
        var amount = num(label);
        if (!isFinite(amount) || acc.some(function (a) { return a.amount === amount; })) return acc;
        acc.push({
          amount: amount,
          label: label.replace(/^\$\s*\d+(?:\.\d+)?\s*[·•-]?\s*/, ''),
          met: el.classList.contains('is-met'),
          next: el.classList.contains('is-next'),
          left: el.style.left
        });
        return acc;
      }, []).sort(function (a, b) { return a.amount - b.amount; });
    }

    /* ── 4. Cards ───────────────────────────────────────────────────────── */
    /* Reviews.io ratings per variant, rendered by Liquid from the products'
       reviews.rating / reviews.rating_count metafields. */
    var RATINGS = (function () {
      try { return JSON.parse((document.getElementById('tnm-builder-v2-ratings') || {}).textContent || '{}'); } catch (e) { return {}; }
    })();
    function ratingFor(card) { return RATINGS[card.dataset.variantId] || null; }

    /* The app's `sizes` assumes two columns on phones. This theme shows one, so
       left alone the browser picks a file half the width the card needs and
       the photos look soft. */
    var CARD_SIZES = '(max-width: 599px) calc(100vw - 24px), (max-width: 1023px) 30vw, 280px';
    function fitCardImages() {
      qa('.ts-bb__card-img[sizes]').forEach(function (img) {
        if (img.getAttribute('sizes') !== CARD_SIZES) img.setAttribute('sizes', CARD_SIZES);
      });
    }

    function enhanceCards() {
      var pct = subPercent();
      qa('[data-ts-bundle-builder] .ts-bb__card[data-variant-id]').forEach(function (card) {
        var priceEl = q('.ts-bb__card-amount', card);
        var meta = txt(q('.ts-bb__card-meta', card));
        var price = num(txt(priceEl));
        var servings = (meta.match(/(\d+)\s*servings?/i) || [])[1];
        var subOn = !!(q('.ts-bb__sub-checkbox') || {}).checked;
        var key = price + '|' + servings + '|' + pct + '|' + subOn;
        var rt = ratingFor(card);
        var banner = q('.ts-bb__card-banner', card) || q('.ts-bb__card-info', card);
        /* Shown at 4.0+ with 5+ reviews; below that a rating line costs more than it earns. */
        if (rt && rt[1] >= 5 && rt[0] >= 4 && banner && !q('.tnm-card-rating', card)) {
          var r = document.createElement('p');
          r.className = 'tnm-card-rating';
          r.setAttribute('aria-label', 'Rated ' + rt[0].toFixed(1) + ' out of 5 from ' + rt[1] + ' reviews');
          var stars = document.createElement('span');
          stars.className = 'tnm-card-rating__stars';
          stars.style.setProperty('--tnm-rating', String(Math.max(0, Math.min(5, rt[0])) / 5 * 100) + '%');
          stars.setAttribute('aria-hidden', 'true');
          var t = document.createElement('span');
          t.textContent = rt[0].toFixed(1) + ' (' + rt[1] + ')';
          t.setAttribute('aria-hidden', 'true');
          r.appendChild(stars); r.appendChild(t);
          banner.appendChild(r);
        }
        if (card.dataset.tnmServing === key) return;
        var row = q('.ts-bb__card-price', card);
        if (!row || !isFinite(price)) return;
        qa('.tnm-card-serving, .tnm-card-sub', card).forEach(function (n) { n.remove(); });
        if (servings && +servings > 0) {
          var s = document.createElement('span');
          s.className = 'tnm-card-serving';
          s.textContent = money(price / +servings) + ' per serving';
          row.appendChild(s);
        }
        /* Subscribed: the widget already prints the subscriber price on the card. */
        if (!subOn && isFinite(pct) && !card.classList.contains('is-sold-out') && !/sold out/i.test(txt(q('.ts-bb__card-foot', card)))) {
          var sub = document.createElement('span');
          sub.className = 'tnm-card-sub';
          sub.innerHTML = '<b></b><span></span>';
          sub.firstChild.textContent = money(Math.round(price * (100 - pct)) / 100);
          sub.lastChild.textContent = 'with Subscribe & Save';
          row.appendChild(sub);
        }
        card.dataset.tnmServing = key;
      });
    }

    /* ── 3. Starters ────────────────────────────────────────────────────── */
    function enhanceStarters() {
      var st = stops();
      if (!st.length) return;
      qa('[data-ts-bundle-builder] .ts-bb__starter').forEach(function (b) {
        var countEl = q('.ts-bb__starter-count', b);
        var price = num((txt(countEl).match(/\$[\d,.]+/) || [])[0]);
        if (!isFinite(price)) return;
        var reached = st.filter(function (s) { return price >= s.amount; });
        var top = reached[reached.length - 1];
        var label = top ? (reached.length === st.length && st.length > 1 ? 'Unlocks every reward' : 'Unlocks ' + top.label.toLowerCase()) : '';
        var key = price + '|' + label;
        if (b.dataset.tnmReward === key) return;
        qa('.tnm-starter-reward', b).forEach(function (n) { n.remove(); });
        if (label && top.amount > st[0].amount) {
          var tag = document.createElement('span');
          tag.className = 'tnm-starter-reward' + (reached.length === st.length ? ' tnm-starter-reward--top' : '');
          tag.textContent = label;
          b.appendChild(tag);
        }
        b.dataset.tnmReward = key;
      });
    }

    /* ── 2. Sort + search behind one toggle in the category bar ─────────── */
    /* Phones only (the button is display:none from 768px). Its visible label
       is its name; the search input keeps "Search cuts" to itself. Opening it
       shows the app's sort select and search box (snippet CSS). F-008. */
    function enhanceToolbar() {
      var bar = q('[data-tnm-categories]');
      var controls = q('[data-ts-bundle-builder] .ts-bb__controls');
      if (!bar || !controls || q('.tnm-cat-search', bar)) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tnm-cat-search';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><span class="tnm-cat-search__label">Sort / Search</span>';
      btn.addEventListener('click', function () {
        var open = !controls.classList.contains('tnm-search-open');
        controls.classList.toggle('tnm-search-open', open);
        btn.setAttribute('aria-expanded', String(open));
        if (open) { var i = q('.ts-bb__search-input', controls); if (i) setTimeout(function () { i.focus(); }, 30); }
      });
      bar.insertBefore(btn, bar.firstChild);
      if (bar.nextSibling !== controls) bar.parentNode.insertBefore(controls, bar.nextSibling);
    }

    /* Dispatch window, mirrored from snippets/pdp-buy-box.liquid (two batches:
       Mon/Tue orders ship Wednesday, Wed-Sun orders ship Monday), evaluated
       in shop time. */
    function shipPromise() {
      var day;
      try { day = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Denver', weekday: 'short'}).format(new Date()); } catch (e) { return ''; }
      var t = {Mon: ['Wednesday', 'Thu\u2013Fri'], Tue: ['Wednesday', 'Thu\u2013Fri'], Wed: ['Monday', 'Tue\u2013Wed'], Thu: ['Monday', 'Tue\u2013Wed'], Fri: ['Monday', 'Tue\u2013Wed'], Sat: ['Monday', 'Tue\u2013Wed'], Sun: ['Monday', 'Tue\u2013Wed']}[day];
      return t ? 'Ships ' + t[0] + ' \u00b7 arrives ' + t[1] : '';
    }

    /* ── 5. Dock ────────────────────────────────────────────────────────── */
    var dock, lastTotal = null, dockCloseIntent = null;
    function rememberDockClose(event) {
      if (!mq.matches || (event.type === 'keydown' && event.key !== 'Escape')) return;
      var target = event.target;
      var summary = target && target.closest && target.closest('.ts-bb-cart-portal.is-stacked .ts-bb__summary.is-expanded');
      if (!summary || (event.type === 'click' && !target.closest('.ts-bb__cart-collapse-toggle'))) return;
      // Capture the close before the app hides its control and the browser
      // blurs it to BODY. The app continues to own the click/Escape behavior.
      dockCloseIntent = summary;
      schedule();
    }
    function buildDock() {
      dock = document.createElement('div');
      dock.className = 'tnm-dock';
      dock.setAttribute('role', 'region');
      dock.setAttribute('aria-label', 'Your box progress');
      dock.innerHTML =
        '<button type="button" class="tnm-dock__handle" aria-expanded="false"></button>' +
        '<div class="tnm-dock__meter" aria-hidden="true"><div class="tnm-dock__fill"></div></div>' +
        '<div class="tnm-dock__labels" aria-hidden="true"></div>' +
        '<p class="tnm-dock__msg" aria-live="polite"></p>' +
        '<p class="tnm-dock__ship"></p>' +
        '<p class="tnm-dock__eta"></p>' +
        '<button type="button" class="tnm-dock__topup" hidden>' +
          '<img alt="" width="36" height="36" loading="lazy" decoding="async">' +
          '<span class="tnm-dock__topup-text"><span class="tnm-dock__topup-title"></span><span class="tnm-dock__topup-note"></span></span>' +
          '<span class="tnm-dock__topup-add" aria-hidden="true">Add</span>' +
        '</button>' +
        '<button type="button" class="tnm-dock__sub" role="switch" aria-checked="false" hidden>' +
          '<span class="tnm-dock__switch" aria-hidden="true"></span>' +
          '<span class="tnm-dock__sub-text"><span class="tnm-dock__sub-title"></span><span class="tnm-dock__sub-note"></span></span>' +
        '</button>';
      document.body.appendChild(dock);
      q('.tnm-dock__handle', dock).addEventListener('click', function () {
        var t = q('.ts-bb-cart-portal .ts-bb__cart-collapse-toggle');
        if (t) {
          t.click();
          var summary = t.closest('.ts-bb__summary');
          // The dock is hidden while expanded. Continue keyboard navigation
          // from the app's visible close control instead of the hidden opener.
          if (summary && summary.classList.contains('is-expanded')) t.focus({preventScroll: true});
        }
      });
      q('.tnm-dock__topup', dock).addEventListener('click', function () {
        var id = this.dataset.variant;
        var card = id && q('[data-ts-bundle-builder] .ts-bb__card[data-variant-id="' + id + '"]');
        if (!card) return;
        var add = q('.ts-bb__card-add', card);
        var plus = q('.ts-bb__step--plus', card);
        var target = (add && add.offsetParent !== null) ? add : plus;
        if (!target || target.disabled) return;
        dock.classList.add('is-busy');
        target.click();
        setTimeout(function () { dock.classList.remove('is-busy'); schedule(); }, 400);
      });
      q('.tnm-dock__sub', dock).addEventListener('click', function () {
        var cb = q('.ts-bb-cart-portal .ts-bb__sub-checkbox');
        if (cb && !cb.disabled) cb.click();
        setTimeout(syncDock, 60);
      });
    }

    function boldAmounts(el, s) {
      el.textContent = '';
      s.split(/(\$[\d,]+(?:\.\d{2})?)/).forEach(function (part, i) {
        if (!part) return;
        if (i % 2) { var b = document.createElement('b'); b.textContent = part; el.appendChild(b); }
        else el.appendChild(document.createTextNode(part));
      });
    }

    /* The subscribe popup ships in the app and still overpromises; say what the
       account really does until that copy changes at the source. */
    function setPerk(item, label, body) {
      var emp = q('strong', item);
      if (!emp) { item.textContent = label + body; return; }
      emp.textContent = label;
      while (emp.nextSibling) emp.parentNode.removeChild(emp.nextSibling);
      emp.parentNode.appendChild(document.createTextNode(body));
    }
    function fixPerks() {
      qa('.ts-bb__perks-item').forEach(function (item) {
        var t = txt(item);
        if (/^Pause or Can/.test(t)) setPerk(item, 'Skip or Pause: ', 'Manage your deliveries from your account before your next renewal.');
        else if (/Customize Every Box/.test(t)) setPerk(item, 'Pick Your Cuts: ', 'Choose the cuts that go in your box.');
      });
    }

    /* Benefits beside the subscribe choice, in the box sheet and desktop summary. */
    /* Phone browsers only draw a scrollbar during a scroll, and iOS ignores
       scrollbar CSS, so nothing says a panel continues. This draws one that
       stays, on the topmost open panel. It lives on <body>, outside the observed
       tree, so moving the thumb on every scroll frame does not re-trigger run(). */
    var phoneMq = window.matchMedia('(max-width: 767px)');
    var sheetBar = null, sheetThumb = null, sheetBarFrame = 0;
    function syncSheetBar() {
      sheetBarFrame = 0;
      var modal = q('.ts-bb__modal-overlay .ts-bb__modal-info') || q('.ts-bb__review-overlay .ts-bb__review-body');
      var scroll = modal || q('.ts-bb-cart-portal.is-stacked .ts-bb__summary.is-expanded .ts-bb__cart-scroll');
      var room = scroll ? scroll.scrollHeight - scroll.clientHeight : 0;
      if (!phoneMq.matches || room < 2) {
        if (sheetBar) sheetBar.hidden = true;
        return;
      }
      if (!sheetBar) {
        sheetBar = document.createElement('div');
        sheetBar.className = 'tnm-sheet-bar';
        sheetBar.setAttribute('aria-hidden', 'true');
        sheetThumb = document.createElement('div');
        sheetThumb.className = 'tnm-sheet-bar__thumb';
        sheetBar.appendChild(sheetThumb);
        document.body.appendChild(sheetBar);
      }
      var box = scroll.getBoundingClientRect();
      var trackH = Math.max(0, box.height - 16);
      var thumbH = Math.max(32, trackH * scroll.clientHeight / scroll.scrollHeight);
      sheetBar.hidden = false;
      sheetBar.classList.toggle('is-over-modal', !!modal);
      sheetBar.style.top = (box.top + 8) + 'px';
      sheetBar.style.left = (Math.min(box.right, document.documentElement.clientWidth) - 8) + 'px';
      sheetBar.style.height = trackH + 'px';
      sheetThumb.style.height = thumbH + 'px';
      sheetThumb.style.transform = 'translateY(' + (trackH - thumbH) * (scroll.scrollTop / room) + 'px)';
    }
    function onSheetScroll() {
      if (sheetBar && !sheetBar.hidden && !sheetBarFrame) sheetBarFrame = requestAnimationFrame(syncSheetBar);
    }
    /* A popup opening or closing, its entrance animation ending and its images
       loading all move the panel without touching the observed tree. */
    function onPanelChange() {
      if (!sheetBarFrame) sheetBarFrame = setTimeout(syncSheetBar, 16);
    }
    function watchPanels() {
      if (typeof MutationObserver === 'function') new MutationObserver(onPanelChange).observe(document.body, {childList: true});
      document.addEventListener('animationend', function (e) {
        if (e.target.closest && e.target.closest('.ts-bb__modal, .ts-bb__review')) onPanelChange();
      }, true);
      document.addEventListener('load', function (e) {
        if (e.target.closest && e.target.closest('.ts-bb__modal-overlay, .ts-bb__review-overlay')) onPanelChange();
      }, true);
    }

    function enhanceSubBenefits() {
      var sub = q('.ts-bb-cart-portal .ts-bb__sub');
      if (!sub || q('.tnm-sub-perks', sub)) return;
      var list = document.createElement('p');
      list.className = 'tnm-sub-perks';
      list.textContent = 'Choose how often it ships \u00b7 Skip or pause before your next renewal';
      sub.appendChild(list);
    }

    function syncDock() {
      var closingSummary = dockCloseIntent;
      dockCloseIntent = null;
      var portal = q('.ts-bb-cart-portal.is-stacked');
      var summary = portal && q('.ts-bb__summary', portal);
      if (!mq.matches || !portal || !summary) {
        if (dock) dock.hidden = true;
        document.body.classList.remove('tnm-has-dock');
        return;
      }
      if (!dock) buildDock();
      var expanded = summary.classList.contains('is-expanded');
      dock.hidden = expanded;
      document.body.classList.toggle('tnm-has-dock', !expanded);

      var count = parseInt((txt(q('.ts-bb__cart-count', summary)).match(/\d+/) || ['0'])[0], 10) || 0;
      var handle = q('.tnm-dock__handle', dock);
      var hLabel = count ? 'Review box (' + count + ')' : 'Your box is empty';
      if (handle.textContent !== hLabel) handle.textContent = hLabel;
      handle.disabled = !count;
      handle.setAttribute('aria-expanded', String(expanded));
      dock.classList.toggle('is-empty', !count);
      // Only a close from this sheet may return focus. CSS can already have
      // blurred the hidden app toggle; preserve any other focused control.
      var active = document.activeElement;
      if (!expanded && closingSummary === summary &&
          (active === document.body || active === document.documentElement || active === q('.ts-bb__cart-collapse-toggle', summary))) {
        var returnTarget = count ? handle : q('[data-tnm-categories] [data-category="all"]');
        if (returnTarget) returnTarget.focus({preventScroll: true});
      }

      /* meter mirrors the widget's own fill width + stop positions */
      var fillSrc = q('.tnm-bb-progress-slot .ts-bb__top-progress-fill') || q('.ts-bb__top-progress-fill');
      var fill = q('.tnm-dock__fill', dock);
      var meter = q('.tnm-dock__meter', dock);
      var st = stops();
      var allMet = st.length && st.every(function (s) { return s.met; });
      if (fillSrc && fillSrc.style.width) fill.style.width = fillSrc.style.width;
      fill.classList.toggle('is-done', !!allMet);
      /* Amount and label are part of the key: the rail first paints its fallback
         threshold and relabels a beat later with the widget's live one, and a
         left/met-only key kept the phone dock on the stale amount ($130 shown
         for the $150 gift, measured live 2026-10-24). */
      var stopKey = st.map(function (s) { return s.left + '$' + s.amount + s.label + (s.met ? 'm' : s.next ? 'n' : ''); }).join(',');
      if (meter.dataset.k !== stopKey) {
        qa('.tnm-dock__stop', meter).forEach(function (n) { n.remove(); });
        st.forEach(function (s) {
          if (!s.left) return;
          var d = document.createElement('span');
          d.className = 'tnm-dock__stop' + (s.met ? ' is-met' : s.next ? ' is-next' : '');
          d.style.left = s.left;
          meter.appendChild(d);
        });
        meter.dataset.k = stopKey;
      }
      meter.hidden = !fillSrc;

      /* message: the widget's own words */
      /* the header rail's message first: tnm-builder-free-shipping extends it
         past the gift to the free-shipping stop; the sheet's copy stops at the gift */
      var src = q('.tnm-bb-progress-slot .ts-bb__top-progress-msg') || q('.ts-bb__bar-msg', summary);
      var msg = q('.tnm-dock__msg', dock);
      var m = txt(src);
      /* The rail appends a "Pick your gift in cart" chip once a gift is earned;
         in the dock that becomes the handle's job (the picker is in the sheet). */
      var giftPending = /pick your (free )?gift/i.test(m);
      m = m.replace(/\s*pick your (free )?gift[\s\S]*$/i, '').trim();
      handle.classList.toggle('is-gift', giftPending && count > 0);
      var hl2 = giftPending && count ? 'Pick your free gift \u00b7 review box (' + count + ')' : (count ? 'Review box (' + count + ')' : 'Your box is empty');
      if (handle.textContent !== hl2) handle.textContent = hl2;
      if (msg.dataset.m !== m) { boldAmounts(msg, m); msg.dataset.m = m; }
      msg.classList.toggle('is-done', !!allMet);

      /* stop labels under the meter, from the widget's own ladder labels */
      var labels = q('.tnm-dock__labels', dock);
      if (labels.dataset.k !== stopKey) {
        labels.textContent = '';
        st.forEach(function (s) {
          if (!s.left) return;
          var l = document.createElement('span');
          l.className = 'tnm-dock__label' + (s.met ? ' is-met' : s.next ? ' is-next' : '');
          l.style.left = s.left;
          l.textContent = '$' + Math.round(s.amount);
          var sm = document.createElement('small');
          sm.textContent = s.label;
          l.appendChild(sm);
          labels.appendChild(l);
        });
        labels.dataset.k = stopKey;
      }
      labels.hidden = !st.length;

      /* shipping, said before checkout (rate + threshold are theme settings
         that mirror the General delivery profile) */
      var total = num(txt(q('.ts-bb__total-amount', summary)));
      var ship = q('.tnm-dock__ship', dock);
      if (SHIP.rate > 0 && isFinite(total) && count) {
        var free = caseShip.free || (SHIP.freeAt > 0 && total >= SHIP.freeAt);
        ship.hidden = false;
        ship.classList.toggle('is-free', free);
        var freeAt = caseShip.hasCase && caseShip.minimum > 0 ? caseShip.minimum : SHIP.freeAt;
        var sText = caseShip.free ? 'FREE|shipping on this order' : free ? 'FREE|shipping on this box' : money(SHIP.rate) + '|shipping' + (freeAt > 0 ? ' \u00b7 free at ' + money(freeAt).replace('.00', '') : '');
        if (ship.dataset.t !== sText) {
          var parts = sText.split('|');
          ship.textContent = '';
          var bb = document.createElement('b'); bb.textContent = parts[0];
          ship.appendChild(bb); ship.appendChild(document.createTextNode(' ' + parts[1]));
          ship.dataset.t = sText;
        }
      } else {
        ship.hidden = true;
      }

      var eta = q('.tnm-dock__eta', dock), promise = count ? shipPromise() : '';
      eta.hidden = !promise;
      if (eta.textContent !== promise) eta.textContent = promise;

      /* one-tap top-up: the single cut that closes the gap to the next reward
         with the least overshoot. Gap = the widget's own "Add $X more" figure;
         prices = the amounts the cards show right now (subscribed or not). */
      var topup = q('.tnm-dock__topup', dock);
      var gapM = m.match(/add\s*\$([\d,]+(?:\.\d{2})?)\s*more/i);
      var gap = gapM ? parseFloat(gapM[1].replace(/,/g, '')) : NaN;
      var nextStop = st.filter(function (s) { return !s.met; })[0];
      var pick = null;
      if (count && isFinite(gap) && gap > 0 && nextStop) {
        qa('[data-ts-bundle-builder] .ts-bb__card[data-variant-id]').forEach(function (card) {
          if (/sold out/i.test(txt(q('.ts-bb__card-foot', card)))) return;
          var plus = q('.ts-bb__step--plus', card), add = q('.ts-bb__card-add', card);
          if ((plus && plus.disabled) && (!add || add.disabled)) return;
          var price = num(txt(q('.ts-bb__card-amount', card)));
          if (!isFinite(price) || price + 0.004 < gap) return;
          if (!pick || price < pick.price) pick = {card: card, price: price};
        });
      }
      if (pick && pick.price - gap <= 20) {
        var title = txt(q('.ts-bb__card-title', pick.card));
        var img = q('.ts-bb__card-img', pick.card);
        /* The first stop is the order minimum: it has nothing to unlock, and
           turning on Subscribe & Save can drop a finished box back below it. */
        var topupGoal = nextStop.amount === st[0].amount ? 'reach the $' + nextStop.amount + ' minimum' : 'unlock ' + nextStop.label.toLowerCase();
        var key2 = pick.card.dataset.variantId + '|' + pick.price + '|' + topupGoal;
        if (topup.dataset.k !== key2) {
          topup.dataset.variant = pick.card.dataset.variantId;
          q('.tnm-dock__topup-title', topup).textContent = title + ' \u00b7 ' + money(pick.price);
          q('.tnm-dock__topup-note', topup).textContent = 'Add it to ' + topupGoal;
          var ti = q('img', topup);
          if (img && img.currentSrc) { ti.src = img.currentSrc.replace(/width=\d+/, 'width=96'); ti.hidden = false; } else { ti.hidden = true; }
          topup.setAttribute('aria-label', 'Add ' + title + ' for ' + money(pick.price) + ' to ' + topupGoal);
          topup.dataset.k = key2;
        }
        topup.hidden = false;
      } else {
        topup.hidden = true;
      }

      /* subscribe switch drives the widget's real checkbox */
      var cb = q('.ts-bb__sub-checkbox', summary);
      var subBtn = q('.tnm-dock__sub', dock);
      var pct = subPercent();
      /* One ask at a time: while a single cut would unlock the next reward,
         that is the dock's offer; the subscribe card stays in the box sheet. */
      if (cb && count && topup.hidden) {
        subBtn.hidden = false;
        subBtn.setAttribute('aria-checked', String(!!cb.checked));
        var t = cb.checked ? 'Subscribed · ' + (isFinite(pct) ? pct + '% off' : 'saving') : 'Subscribe & save' + (isFinite(pct) ? ' ' + pct + '%' : '');
        var save = (!cb.checked && isFinite(pct) && isFinite(total)) ? Math.round(total * pct) / 100 : NaN;
        /* No cancellation terms here (Bob, 2026-10-24): a cancel-before-renewal
           clause under the subscribe switch is a reason to stop; the policy link
           carries the terms and the subscribe modal explains pause and skip. */
        var n = cb.checked ? 'Skip or pause anytime' : (save >= 1 ? 'Save ' + money(save) + ' on this box \u00b7 skip or pause anytime' : 'Tap to switch from a one-time order \u00b7 skip or pause anytime');
        var title = q('.tnm-dock__sub-title', subBtn), note = q('.tnm-dock__sub-note', subBtn);
        if (title.textContent !== t) title.textContent = t;
        if (note.textContent !== n) note.textContent = n;
      } else {
        subBtn.hidden = true;
      }

      /* place the dock directly above the widget's bottom bar */
      var r = summary.getBoundingClientRect();
      var below = Math.max(0, Math.round(window.innerHeight - r.top));
      document.documentElement.style.setProperty('--tnm-dock-bottom', below + 'px');
      document.documentElement.style.setProperty('--tnm-dock-total', (below + dock.offsetHeight) + 'px');

      if (lastTotal !== null && isFinite(total) && total > lastTotal && !expanded) {
        dock.classList.remove('is-pulse'); void dock.offsetWidth; dock.classList.add('is-pulse');
      }
      if (isFinite(total)) lastTotal = total;
    }


    /* Debounced, not per-frame: while the widget boots it mutates the DOM in
       bursts, and one pass after the burst is all the layer needs (keeps TBT
       flat). Attributes are watched only where state lives in them: the
       sheet's is-expanded class and the rail's fill width / met stops. */
    var timer = 0;
    function run() {
      timer = 0;
      if (observer) observer.disconnect();
      refreshCaseShip();
      try { enhanceToolbar(); enhanceStarters(); fitCardImages(); enhanceCards(); enhanceSubBenefits(); fixPerks(); syncDock(); syncSheetBar(); }
      finally { observe(); }
    }
    function schedule() { if (!timer) timer = setTimeout(run, 90); }
    var observer = typeof MutationObserver === 'function' ? new MutationObserver(schedule) : null;
    function observe() {
      if (!observer) return;
      var tree = {childList: true, subtree: true, characterData: true};
      var attrs = {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'disabled']};
      var w = q('[data-ts-bundle-builder]'), portal = q('.ts-bb-cart-portal'), slot = q('.tnm-bb-progress-slot');
      if (w) observer.observe(w, tree);
      if (portal) observer.observe(portal, attrs);
      if (slot) observer.observe(slot, attrs);
      observer.observe(document.body, {childList: true});
    }
    function start() {
      if (!q('[data-ts-bundle-builder]')) { setTimeout(start, 300); return; }
      run();
      document.addEventListener('scroll', onSheetScroll, {capture: true, passive: true});
      watchPanels();
      document.addEventListener('click', rememberDockClose, true);
      document.addEventListener('keydown', rememberDockClose, true);
      document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('ts-bb__sub-checkbox')) schedule(); }, true);
      window.addEventListener('resize', schedule, {passive: true});
      if (mq.addEventListener) mq.addEventListener('change', schedule);
      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(schedule);
        var attach = function () { var s = q('.ts-bb-cart-portal .ts-bb__summary'); if (s && !s.__tnmRo) { s.__tnmRo = 1; ro.observe(s); } };
        attach(); setInterval(attach, 1500);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

